<template>
  <div class="edit">
    <div class="edit-content">
      <div class="edit-item edit-item2">
        审批通过后且开通智能人事微应用，员工将自动进入待入职名单。
      </div>

      <div class="edit-item">
        <div class="title">选择员工档案字段:</div>
      </div>
      <div class="edit-title-top">基本信息</div>
      <div v-for="(ele, index) in editForm.formProps" :key="index">
        <template v-if="ele.label == '邮箱'">
          <div class="edit-item">
            <div class="title">邮箱</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
      </div>
      <template>
        <div class="edit-title-top">工作信息</div>
        <div v-for="ele in editForm.formProps" :key="ele.label">
          <template v-if="ele.label == '工号'">
            <div class="edit-item">
              <div class="title">工号</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
          <template v-if="ele.label == '分机号'">
            <div class="edit-item">
              <div class="title">分机号</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
          <template v-if="ele.label == '办公地点'">
            <div class="edit-item">
              <div class="title">办公地点</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
          <template v-if="ele.label == '试用期'">
            <div class="edit-item">
              <div class="title">试用期</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
          <template v-if="ele.label == '转正日期'">
            <div class="edit-item">
              <div class="title">转正日期</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
          <template v-if="ele.label == '岗位职级'">
            <div class="edit-item">
              <div class="title">岗位职级</div>

              <el-switch
                v-model="ele.show"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
            </div>
          </template>
        </div>
      </template>
      <div class="edit-title-top">个人信息</div>
      <div v-for="(ele, index) in editForm.formProps" :key="ele.label + index">
        <template v-if="ele.label == '身份证姓名'">
          <div class="edit-item">
            <div class="title">身份证姓名</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '证件号码'">
          <div class="edit-item">
            <div class="title">证件号码</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '年龄'">
          <div class="edit-item">
            <div class="title">年龄</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '性别'">
          <div class="edit-item">
            <div class="title">性别</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '首次参加工作时间'">
          <div class="edit-item">
            <div class="title">首次参加工作时间</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '工龄'">
          <div class="edit-item">
            <div class="title">工龄</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
      </div>

      <div class="edit-title-top">学历信息</div>
      <div
        v-for="(ele, index) in editForm.formProps"
        :key="ele.label + index + index"
      >
        <template v-if="ele.label == '学历'">
          <div class="edit-item">
            <div class="title">学历</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '毕业院校'">
          <div class="edit-item">
            <div class="title">毕业院校</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '毕业时间'">
          <div class="edit-item">
            <div class="title">毕业时间</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '所学专业'">
          <div class="edit-item">
            <div class="title">所学专业</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
      </div>

      <div class="edit-title-top">银行卡信息</div>
      <div
        v-for="(ele, index) in editForm.formProps"
        :key="ele.label + index + index + index"
      >
        <template v-if="ele.label == '银行卡号'">
          <div class="edit-item">
            <div class="title">银行卡号</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '开户行'">
          <div class="edit-item">
            <div class="title">开户行</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
      </div>
      <div class="edit-title-top">合同信息</div>
      <div
        v-for="(ele, index) in editForm.formProps"
        :key="ele.label + index + index + index + index"
      >
        <template v-if="ele.label == '合同公司'">
          <div class="edit-item">
            <div class="title">合同公司</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '合同类型'">
          <div class="edit-item">
            <div class="title">合同类型</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '合同起始日'">
          <div class="edit-item">
            <div class="title">合同起始日</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
        <template v-if="ele.label == '合同到期日'">
          <div class="edit-item">
            <div class="title">合同到期日</div>

            <el-switch v-model="ele.show" :active-value="1" :inactive-value="0">
            </el-switch>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect() {
      this.$emit("removeSelect");
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-title-top {
  font-size: 16px;
  font-weight: bold;
  // margin-bottom: 12px 0;
  color: #222 !important;
}
.edit-item2 {
  font-size: 12px;
}
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title-top {
  color: #0f66f2;
  margin-bottom: 10px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  display: flex;
  margin-bottom: 12px;
  align-items: center;

  .title {
    margin-right: 10px;
    width: 150px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
